/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dynamic_Ui_DoneInputs */

const en_dynamic_ui_done = /** @type {(inputs: Dynamic_Ui_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done!`)
};

const ar_dynamic_ui_done = /** @type {(inputs: Dynamic_Ui_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم!`)
};

const bn_dynamic_ui_done = /** @type {(inputs: Dynamic_Ui_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হয়ে গেছে!`)
};

const de_dynamic_ui_done = /** @type {(inputs: Dynamic_Ui_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig!`)
};

const es_dynamic_ui_done = /** @type {(inputs: Dynamic_Ui_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Listo!`)
};

const fr_dynamic_ui_done = /** @type {(inputs: Dynamic_Ui_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé !`)
};

const pt_dynamic_ui_done = /** @type {(inputs: Dynamic_Ui_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto!`)
};

const zh_dynamic_ui_done = /** @type {(inputs: Dynamic_Ui_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成！`)
};

const tr_dynamic_ui_done = /** @type {(inputs: Dynamic_Ui_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitti!`)
};

const ru_dynamic_ui_done = /** @type {(inputs: Dynamic_Ui_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готово!`)
};

const pl_dynamic_ui_done = /** @type {(inputs: Dynamic_Ui_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowe!`)
};

/**
* | output |
* | --- |
* | "Done!" |
*
* @param {Dynamic_Ui_DoneInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dynamic_ui_done = /** @type {((inputs?: Dynamic_Ui_DoneInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dynamic_Ui_DoneInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dynamic_ui_done(inputs)
	if (locale === "bn") return bn_dynamic_ui_done(inputs)
	if (locale === "de") return de_dynamic_ui_done(inputs)
	if (locale === "es") return es_dynamic_ui_done(inputs)
	if (locale === "fr") return fr_dynamic_ui_done(inputs)
	if (locale === "pt") return pt_dynamic_ui_done(inputs)
	if (locale === "zh") return zh_dynamic_ui_done(inputs)
	if (locale === "tr") return tr_dynamic_ui_done(inputs)
	if (locale === "ru") return ru_dynamic_ui_done(inputs)
	if (locale === "pl") return pl_dynamic_ui_done(inputs)
	return en_dynamic_ui_done(inputs)
});